import React from 'react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import useStyles from '../useStyles';
import { clsx } from '@components/Provider';

const ITPRewardExchangeCTA = () => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes['Chat-Message-Bubble-Common-root'], {
        owner: true
      })}
    >
      <CustomizedTypography
        variant="body2"
        fontWeight="700"
        color="primary"
        gutterBottoms={8}
      >
        이벤트 보상 신청
      </CustomizedTypography>
      <CustomizedTypography
        variant="body2"
        color="textPrimary"
        gutterBottoms={16}
      >
        거래완료되어 ITP 이벤트 보상 신청이 지금 바로 가능합니다! 스타벅스 쿠폰,
        150만원 상당의 3D 프린터 받아가세요!
      </CustomizedTypography>
      <CustomizedButton color="primary" disabled={true} fullWidth>
        이벤트 보상 신청하러 가기
      </CustomizedButton>
    </div>
  );
};

export default ITPRewardExchangeCTA;
